export default {
    company: {
        name: "宜宾纸业"
    },
    nav: {
        home: "首页",
        about: "关于我们",
        products: "产品中心",
        contact: "联系我们",
        sustainability: "可持续发展",
        technology: "技术创新"
    },
    banner: {
        title: "竹韵雅纸 · 绿色未来",
        subtitle: "传承千年造纸工艺，引领竹浆造纸新标准"
    },
    products: {
        subtitle: "优质竹浆纸品，满足多样需求",
        description: "我们提供全方位的纸制品解决方案，从原纸到成品，满足您的各种需求",
        viewDetails: "查看详情",
        categories: {
            title: "产品系列",
            subtitle: "竹浆纸制品，引领绿色消费新风尚",
            livingPaper: "生活用纸原纸",
            livingPaperDesc: "生活用纸原纸系列产品",
            foodPaper: "食品包装原纸",
            foodPaperDesc: "食品包装原纸系列产品",
            finishedProducts: "生活用纸成品系列"
        },
        advantages: {
            title: "产品优势",
            subtitle: "以竹之名，焕新生活"
        },
        applications: {
            title: "应用领域",
            subtitle: "广泛应用于日常生活和各行各业"
        },
        cta: {
            title: "需要定制产品解决方案？",
            description: "我们可以根据您的需求提供专业的竹浆纸产品定制服务",
            buttonText: "联系我们"
        },
        detail: {
            features: '产品特点',
            contactUs: '联系我们',
            specifications: '产品规格',
            usageScenarios: '使用场景',
            relatedProducts: '相关产品',
            cta: {
                title: '需要更多产品信息？',
                description: '我们的产品顾问随时为您提供专业的咨询和定制方案',
                buttonText: '联系我们'
            }
        },
        title: "主要产品"
    },
    advantages: {
        title: "我们的优势",
        subtitle: "竹浆造纸，环保科技，品质卓越",
        items: {
            experience: {
                title: "深厚的行业经验积累",
                description: "80载技术沉淀，完善的制浆造纸及配套全产业链，为绿色低碳生物基材料转型提供坚实技术支撑。"
            },
            production: {
                title: "成熟规模化生产体系",
                description: "完备的生产设施与自动化产线，可快速响应客户需求，实现低成本、高效率量产。"
            },
            innovation: {
                title: "产学研合作研发创新",
                description: "与高校及科研机构共建有联合实验室，专注低碳工艺与可再生材料研发，加速生物基材料等前沿技术的产业化落地。"
            },
            certification: {
                title: "全链条绿色资质认证",
                description: "从原料采购到产品生产通过FSC、医护级产品、卫生安全产品等认证，提升产品市场竞争力。"
            }
        }
    },
    footer: {
        contact: "联系我们",
        address: "地址：四川省宜宾市南溪区裴石轻工业园区宜宾纸业",
        phone: "电话：0831-3309663",
        email: "邮箱：ybzy@yb-zy.com",
        quickLinks: "快速链接",
        moreInfo: "更多信息",
        // news: "新闻动态",
        // careers: "招贤纳士",
        followUs: "关注我们",
        wechat: "微信公众号：宜宾纸业",
        rights: "版权所有",
        slogan: "竹浆造纸，绿色创新"
    },
    about: {
        companyProfile: "公司简介",
        established: "始建于1944年",
        formerName: `前身为"中国纸厂"`,
        firstNewsprint: "第一张国产机制新闻纸诞生地",
        listed: "1997年在上交所上市（股票代码：600793）",
        firstListed: "中国造纸行业的第一家上市公司",
        firstYibinListed: "宜宾市第一家上市公司",
        wuliangyeSubsidiary: "五粮液集团公司控股子公司",
        firstNewMeterial: "首批“60+10”新型竹材料标志性产品链链主企业",
        capacity: "产能情况",
        mainCapacity: "本部公司浆纸总产能54万吨/年",
        managedCapacity: "托管公司浆纸总产能12万吨/年",
        newMaterialCapacity: "新材料瓦楞纸箱产能1亿平方米/年",
        bambooMoldingCapacity: "新材料竹浆模塑产能6600吨/年",
        celluloseCapacity: "醋酸纤维素产能3万吨/年",
        historyTitle: "发展历程",
        historySubtitle: "七十余年砥砺前行，铸就竹浆造纸品牌",
        historyItems: {
            "1944": "中国造纸厂成立，开启中国造纸工业史",
            "1945": "成功生产我国第一张百分之百机械木浆新闻纸",
            "1950": `"中国纸厂"更名为"宜宾造纸厂"`,
            "1961": "朱德委员长来厂视察",
            "1966": "彭德怀元帅来厂视察",
            "1988": "进行股份制试点，设立'宜宾纸业股份有限公司'",
            "1997": "在上海证券交易所挂牌上市",
            "2012": "宜宾纸业整体搬迁开工奠基",
            "2015": "新区食品包装原纸生产线建成投产",
            "2018_1": "新区生活用纸生产线建成投产",
            "2018_2": "五粮液集团公司控股子公司",
            "2025": "全面开启从传统造纸产业向打造绿碳特种生物基材料产业综合集团的未来战略发展之路"
        },
        futureDevelopment: "未来发展",
        future: {
            point1: "全面聚焦发展目标",
            point2: "充分发挥竹资源特点优势",
            point3: "加快向特种化、高技术、高附加值业务转型",
            point4: "全力打造纸品细分产业领域世界级小巨人"
        },
        coreValues: "企业理念",
        coreValuesSubtitle: "竹为骨，纸为魂，绿色创新驱动发展",
        values: {
            mission: "企业使命",
            missionLine1: "以生物新材为基",
            missionLine2: "创绿碳美好世界",
            vision: "企业愿景",
            visionLine1: "打造绿碳特种生物基",
            visionLine2: "材料产业综合集团",
            coreValues: "核心价值观",
            coreValuesLine1: "质量第一、创新驱动",
            coreValuesLine2: "绿色发展、共创共赢",
            philosophy: "经营理念",
            philosophyLine1: "以客户为中心",
            philosophyLine2: "以质量为基础  以创新为动力"
        },
        certificationsTitle: "资质认证",
        certificationsSubtitle: "品质保证，行业认可",
        certificationItems: {
            fsc: "国际森林认证",
            fscDesc: "国际森林认证，原料来自负责任的森林资源",
            iso9001: "ISO9001认证",
            iso9001Desc: "国际质量管理体系认证证书",
            iso14001: "FSSC22000认证",
            iso14001Desc: "食品安全体系认证证书",
            medical: "医护级产品认证",
            medicalDesc: "医护级产品认证证书",
            antibacterial: "抗菌卫生认证",
            antibacterialDesc: "抗菌卫生认证证书",
            safety: "卫生安全产品认证",
            safetyDesc: "卫生安全产品认证证书"
        },
        honorsTitle: "公司荣誉",
        honorsSubtitle: "品质保证，行业认可",
        honorItems: {
            greenFactory: "国家绿色工厂",
            greenFactoryDesc: "中国工信部授予绿色制造标杆企业称号",
            forestryLeader: "国家林业重点龙头企业",
            forestryLeaderDesc: "国家林业和草原局授予的重点龙头企业称号",
            agriculturalProduct: "中国优秀农产品企业",
            agriculturalProductDesc: "中国优秀农产品企业品牌",
            lightIndustry: "全国轻工行业先进集体",
            lightIndustryDesc: "全国轻工行业先进集体",
            bambooProduct: "竹产品十强企业",
            bambooProductDesc: "中国竹产业品牌十强企业",
            engineeringCenter: "造纸工程技术研究中心",
            engineeringCenterDesc: "四川省竹子制浆造纸工程技术研究中心"
        },
        productHonorsTitle: "产品荣誉",
        productHonorsSubtitle: "品质保证，行业认可",
        productHonorItems: {
            industryExcellence: "行业匠心产品",
            neZhaExcellence: "哪吒系列获得2025中国生活用纸行业匠心产品",
            moDiKaExcellence: "莫迪卡系列获得中国生活用纸行业匠心产品",
            bambooExpoGold: "国际竹博会金奖",
            moDiKaGold: "莫迪卡系列获得2025国际竹博会金奖",
            shanghaiExpoGold: "国际竹博会金奖",
            jinZhuGold: "金竹本色系列获得2020上海国际竹博览会金奖",
            quanZhuGold: "全竹包装原纸获得2018上海国际竹博览会金奖",
            westernExpoGold: "中国西部林业产业博览会金奖",
            jinZhuWesternGold: "金竹本色系列获得中国西部林产博览会金奖"
        },
        cta: {
            title: "加入宜宾纸业，共创绿色未来",
            description: "我们期待与您携手合作，共同推动竹浆造纸产业的可持续发展",
            buttonText: "联系我们"
        }
    },
    technology: {
        title: '技术创新',
        subtitle: '科技引领，绿色革新，打造竹浆造纸行业新标杆',
        innovation: {
            title: '创新驱动发展',
            subtitle: '科技引领，绿色革新，打造竹浆造纸行业新标杆',
            management: {
                title: '创新管理体系高效协同',
                content: '宜宾纸业始终将技术创新视为企业发展的核心动力，设立战略与发展委员会，统筹研发、生产、市场三大板块，打造"总部技术研发部+生产基地"的创新架构，并配套柔性激励机制，确保技术创新到产业化的全流程高效落地。'
            },
            team: {
                title: '专业团队引领技术突破',
                content: '依托省级创新平台与研发创新团队，多所知名高校和研究机构保持紧密合作，聚焦低碳制浆、生物基材料等前沿领域开展研发项目，为企业创新发展提供强劲动力。'
            },
            results: {
                title: '创新成果赋能产业升级',
                content: '掌握竹材制浆造纸全链条核心技术，通过技术创新在绿色制浆、清洁生产、资源化综合利用等方面不断取得突破，引领企业向绿色低碳生物基材料产业转型升级。'
            }
        },
        core: {
            title: '核心技术',
            subtitle: '科技引领，绿色创新',
            tabs: {
                pulping: '竹材制浆技术',
                bleaching: '循环经济核心技术',
                papermaking: '绿色产品创新技术'
            },
            items: {
                pulping: {
                    details: [
                        {
                            title: '竹材预处理技术体系',
                            content: '突破竹材高密度、高硅含量的处理难题，开发竹材均质浸渍技术，降低能耗10%以上。'
                        },
                        {
                            title: '低碳清洁制浆技术',
                            content: '"深度脱木素-ECF漂白"联用工艺，AOX排放量相较国家标准低30%以上；集成"厌氧+好氧+芬顿"水处理技术，COD排放量相较国标低50%以上。'
                        }
                    ]
                },
                bleaching: {
                    details: [
                        {
                            title: '竹材全组分利用技术',
                            content: '竹纤维素用于制浆造纸；黑液木质素燃烧回收热能，吨浆可发电350kWh；制浆废弃物制备生物肥料回馈自然。'
                        }
                    ]
                },
                papermaking: {
                    details: [
                        {
                            title: '功能性竹纤维产品',
                            content: '竹纤维增强技术，提高包装纸抗拉、抗折强度指标50%以上，赋予产品更好性能；开发自抗菌生活用纸产品，利用竹材天然抑菌成分，同等条件下提升抑菌效率90%以上。'
                        },
                        {
                            title: '生物基新材料',
                            content: '竹纤维产品替代塑料制品，碳足迹减少60%。'
                        }
                    ]
                }
            }
        },
        research: {
            title: '研发中心',
            subtitle: '专注研发、创造价值',
            imageAlt: '宜宾纸业研发中心',
            center: {
                title: '研发创新平台',
                content: '研发中心成立于2003年，是公司技术创新核心部门，聚焦于行业发展趋势，推动科技成果转化。公司现为省级企业技术中心，拥有四川省竹子制浆造纸工程技术研究中心2个省级创新平台。牵头成立“新型竹产业产教融合共同体”并参与“竹浆纸一体化关键技术研究”国家重点专项项目。在竹浆纸生产的关键技术领域积累了丰富经验，形成了较强的技术竞争优势。'
            },
            cooperation: {
                title: '合作研发',
                content: '中心与四川农业大学、华南理工大学、北京林业大学、南京林业大学、中国林科研究院等多家高校和科研机构建立了长期合作关系，共同承担国家和省部级科研项目，推动产学研深度融合。'
            }
        },
        patents: {
            title: '专利与成果',
            subtitle: '技术积累，行业引领',
            authorized: {
                title: '授权专利',
                items: [
                    '一种精制混合竹浆及其制备方法以及该精制混合竹浆在造纸中的应用',
                    '一种精制竹浆及其制备方法以及该精制竹浆在造纸中的应用',
                    '一种碱回收炉黑液喷枪',
                    '一种纤维筛选装置'
                ]
            },
            projects: {
                title: '科研项目',
                items: [
                    '高松厚高强度竹浆清洁节能制造和高强包装纸板配抄技术研究',
                    '竹材化学浆纯化和高档生活用纸配抄技术研究',
                    '竹基浆精深加工技术研究与开发',
                    '竹基高品质纤维素纤维研究与开发',
                    '功能性木质素高值化产品研究与开发'
                ]
            },
            awards: {
                title: '科技奖项',
                items: [
                    '四川省科技进步一等奖'
                ]
            },
            papers: {
                title: '研究论文',
                items: [
                    '阳离子分散松香胶中总松香和硫酸铝含量的测定',
                    '含竹化机浆本色食品卡纸的试制',
                    '蒸煮助剂在全竹材DDS蒸煮中的应用',
                    '通过纤维分级实现竹纤维资源在溶解浆生产中的高效利用新工艺：实验室研究与工厂试验',
                    '光催化预氧化-超声空化解聚串联策略用于木质素高值化利用'
                ]
            }
        },
        projects: {
            title: '创新项目',
            subtitle: '引领行业未来发展方向',
            items: [
                {
                    title: '四川竹产业链关键技术集成与示范工厂',
                    period: '2019-2022',
                    cooperation: '四川农大',
                    desc: '将竹资源链与产业链进行有机融合，推动竹产业发展。'
                },
                {
                    title: '宜宾林竹产业高新技术创新平台建设与示范',
                    period: '2019-2022',
                    cooperation: '华南理工',
                    desc: '竹材低硫蒸煮技术、黑液高值化利用技术等取得突破。'
                },
                {
                    title: '竹基浆精深加工技术研究与开发',
                    period: '2022-2024',
                    cooperation: '中国林科院',
                    desc: '突破竹材高得率制浆等关键技术，进行产业化运用，实现原材料进口替代。'
                },
                {
                    title: '功能性木质素高值化产品研究与开发',
                    period: '2022-2024',
                    cooperation: '北京林大',
                    desc: '从竹浆制浆黑液中分级提取木质素组分制备副产品，突破黑液高值化利用途径。'
                },
                {
                    title: '竹浆纸一体化关键技术研究',
                    period: '2023-2028',
                    cooperation: '中国林科院',
                    desc: '高效均质浸渍软化、精准解离节能磨浆、碱性过氧化氢活化漂白等关键技术。'
                },
                {
                    title: '智慧竹业关键技术研究与集成示范',
                    period: '2024-2027',
                    cooperation: '南京林大',
                    desc: '竹浆造纸企业清洁制造、资源综合利用等关键技术难题开展课题研究。'
                }
            ]
        },
        cta: {
            title: '共同探索竹浆造纸的未来',
            subtitle: '欢迎有志于竹浆纸技术创新的伙伴与我们联系，共同推动行业发展',
            button: '联系我们'
        }
    },
    sustainability: {
        title: '可持续发展',
        subtitle: '以竹为基，创新为翼，打造绿色低碳生物基材料产业标杆',
        vision: {
            title: '可持续发展愿景',
            content: '以竹为基，创新为翼，打造绿色低碳生物基材料产业标杆',
            imageAlt: '宜宾纸业可持续发展愿景',
            intro1: '作为竹材制浆造纸行业的革新者，',
            intro2: '宜宾纸业坚持以"竹资源高效利用+低碳科技"为核心，推动传统产业向绿色化、高值化、循环化转型。',
            items: {
                circular: {
                    title: '绿色低碳，引领循环经济',
                    content: '依托竹材可再生、速生固碳的特性，构建"竹资源—清洁制浆—生物基材料—低碳产品"全产业链，实现"零废弃、全利用"，助力30/60"双碳"目标。'
                },
                innovation: {
                    title: '科技创新，驱动高值转化',
                    content: '突破竹纤维高值化利用技术，开发可降解包装、生物基复合材料等替塑新产品，减少全生命周期碳足迹。'
                },
                rural: {
                    title: '生态共赢，赋能乡村振兴',
                    content: '通过"竹林基地+绿色工厂+社区共生"模式，促进竹林碳汇增收，带动产业链上下游协同发展，实现环境效益、经济效益与社会效益的统一。'
                },
                cooperation: {
                    title: '开放协作，共建可持续未来',
                    content: '联合科研机构及产业链伙伴，推动竹基材料标准制定与技术推广应用，让"以竹代塑、以竹代木"成为全球绿色解决方案。'
                }
            },
            commitment: {
                title: '我们的承诺：',
                content: '每一根竹子，都是自然与科技的共生；每一份创新，皆为地球与人类的未来。'
            }
        },
        cleanProduction: {
            title: '清洁生产',
            subtitle: '以创新科技守护绿水青山，用清洁生产引领可持续发展',
            description: '宜宾纸业作为竹材制浆造纸行业的绿色先锋，始终践行"环保优先、绿色发展"理念，通过清洁生产工艺、资源循环利用和低碳技术创新，打造高效、清洁、可持续的现代化造纸产业，为全球客户提供绿色纸品解决方案。',
            items: {
                raw: {
                    title: '绿色原料、低碳源头',
                    subtitle: '100%可持续竹纤维，生产废弃物综合利用',
                    points: [
                        '采用速生竹林资源，减少森林砍伐',
                        '竹材生长过程固碳能力强，从源头降低碳排放',
                        '探索竹屑、白泥等生产废弃物综合利用途径，实现资源高效循环'
                    ]
                },
                process: {
                    title: '清洁工艺、节能降耗',
                    subtitle: '低污染制浆技术，废水废气超低排放',
                    points: [
                        '采用无元素氯（ECF）漂白、氧脱木素等先进工艺，大幅减少AOX（可吸附有机卤化物）等有害物质排放',
                        '通过厌氧+好氧生物处理等技术组合，实现废水达标排放，中水回用于原料洗涤，减少新鲜水消耗',
                        '配备碱回收炉+静电除尘+湿法脱硫系统，确保烟气排放优于国家标准'
                    ]
                },
                recycle: {
                    title: '循环经济、变废为宝',
                    subtitle: '黑液100%回收，污泥资源化，余热再利用',
                    points: [
                        '制浆废液经碱回收系统转化为热能及化学品，自给率超85%，减少化石能源依赖',
                        '造纸污泥用于生产有机肥或生物质燃料，实现固废"零填埋"',
                        '生产过程中的余热用于发电，提升能源利用效率'
                    ]
                },
                product: {
                    title: '绿色产品、低碳生活',
                    subtitle: '可降解包装纸，FSC认证产品',
                    points: [
                        '竹纤维食品级包装纸，替代塑料制品，减少"白色污染"',
                        '确保纸张来源符合国际森林可持续经营标准，满足高端市场需求'
                    ]
                }
            }
        },
        circularEconomy: {
            title: '循环经济',
            subtitle: '竹尽其用、生生不息',
            imageAlt: '循环经济模式图',
            intro: {
                title: '以竹代木、以绿赋能',
                content: '作为竹资源高效利用的倡导者，我们打造了"竹-浆-纸-能-肥"五位一体的循环经济模式，让每一根竹子都焕发绿色能量。'
            },
            items: {
                source: {
                    title: '绿色起点：可持续竹源',
                    points: [
                        '建立生态竹林示范基地，采用轮伐管理模式。',
                        '竹材生长速度快（3-5年成材），固碳能力是杉木的1.5倍。',
                        '带动10万农户增收，实现"绿水青山"向"金山银山"转化。'
                    ]
                },
                core: {
                    title: '核心循环：三废零排放',
                    points: [
                        '废液→能源：制浆黑液100%回收，年发电0.6亿度。',
                        '废气→资源：锅炉烟气余热回用，减少CO2排放。',
                        '废渣→碳源：竹屑制成生物质颗粒燃料。'
                    ]
                },
                upgrade: {
                    title: '产品升级：全竹利用',
                    points: [
                        '高档竹浆食品包装、生活用纸（FSC认证）。',
                        '竹纤维可降解包装材料（替代塑料）。',
                        '竹屑竹渣制备生物质废料。'
                    ]
                }
            },
            vision: {
                title: '我们的愿景：',
                content: '让每根竹子完成从碳汇到产品的绿色旅程。'
            }
        },
        socialResponsibility: {
            title: '社会责任',
            subtitle: '润物无声，善行天下',
            tabs: {
                community: '社区发展',
                farmers: '助农增收',
                education: '人才培养',
                biodiversity: '环境友好'
            },
            community: {
                title: '乡村振兴计划',
                description: '宜宾纸业积极响应国家乡村振兴战略，通过"企业+合作社+农户"模式，带动周边乡村发展竹产业，提升乡村经济活力。',
                items: {
                    village: {
                        title: '驻村帮扶',
                        content: '公司先后选派2名党员干部在翠屏区永兴镇狮子村担任驻村第一书记，选派1名党员干部到江安县阳春镇兴旺村担任驻村工作队员。'
                    },
                    manager: {
                        title: '集体经济职业经理人',
                        content1: '先后选派2名骨干人才到村担任"职业经理人"，做好村财监管、制度规范、市场拓展、产品营销、培养经营能人等工作，助力提升村集体经济规范化、市场化和专业化水平。',
                    },
                    project: {
                        title: '兴文县大河苗族乡产业发展合作共赢一对一联系项目',
                        content: '根据《宜宾市企业联系民族乡合作共赢一对一联系机制运行方案》工作要求，公司联系兴文县大河苗族乡，解决竹原料销售困难的问题。'
                    }
                }
            },
            farmers: {
                title: '助农增收工程',
                description: '我们与当地竹农建立了稳定的合作关系，通过直采模式、投入智能化装备、推广科学育种等措施，帮助竹农增加收入，实现共同富裕。',
                imageAlt: '助农增收工程',
                items: {
                    direct: {
                        title: '直采自控砍掉中间商，保护竹农利益',
                        content1: '打破传统收购模式，建立"企业+专合社料场+农户"、"企业+自建料场+农户"等多种直采模式。',
                        content2: '强化一二产深度合作，砍掉中间商，挖掘各环节成本潜力，在保障原料供应的同时，方便竹农卖竹，稳定竹价，保护竹农利益。'
                    },
                    tech: {
                        title: '技术赋能产业升级，提高竹农收入',
                        content1: '加大智能化装备的投入，围绕竹子采伐和运输环节，研究能采伐竹子和运输竹子机具。',
                        content2: '全面提高竹子采伐和运输效率，彻底解放劳动力，降低采伐成本，并与竹农共享技术红利，提高竹农收入。',
                        content3: '通过科学育种、种植和管护示范，实现竹林高产示范带动作用。',
                        content4: '引导竹农科学种植，降低种植和管护成本，提高亩产量，增加竹农种竹收益。'
                    },
                    value: {
                        title: '增值合作拓展渠道，提升综合收益',
                        content1: '开积极探索多元化合作模式，激活竹林"非材化收益"，联合第三方机构试点竹林碳汇交易，农户可凭管护成效获得额外分红。',
                        content2: '同时引导发展林下种养殖，提升竹林综合收益；林下经济与碳汇经营结合，提升竹林固碳能力，增加农户收入，实现"生态+经济"双赢。'
                    }
                }
            },
            education: {
                title: '竹材人才培养计划',
                description: '人才是驱动发展的核心引擎。我们重视人才的培养，通过构建多元化人才培养机制，培养行业未来人才。',
                imageAlt: '人才培养项目',
                items: {
                    mechanism: {
                        title: '多元化人才培养机制',
                        content: '通过"师带徒"、后备人才储备、轮岗实践、定制化培训课程等机制帮助员工实现从职场新人到行业精英的蜕变。'
                    },
                    path: {
                        title: '完善的发展路径',
                        content: '不断完善的晋升通道与多元发展路径，让每位成员都能在擅长领域绽放价值，与公司共赴成长新征程。'
                    }
                }
            },
            biodiversity: {
                title: '绿色工厂计划',
                description: '我们积极响应国家"双碳"目标，将可持续发展作为战略重点，持续优化环境管理体系。',
                imageAlt: '环境友好项目',
                items: {
                    policy: {
                        title: '"以竹代木" "以竹代塑"',
                        content: '积极响应政府"以竹代木""以竹代塑"政策号召，降低生产对自然资源的影响，向低碳经济过渡，实现经济效益和环境效益双赢。'
                    },
                    factory: {
                        title: '绿色工厂',
                        content: '已通过FSCFM/CoC森林认证，并被评为国家级"绿色工厂"企业、四川省"清洁生产"企业，产品荣获"四川省节能环保品牌优秀产品奖"。'
                    }
                }
            }
        },
        report: {
            title: '可持续发展报告',
            subtitle: '透明、真实、全面的可持续发展信息披露',
            download: '下载报告',
            items: {
                '2024': {
                    title: '2024年可持续发展报告',
                    date: '发布日期：2024年4月',
                    imageAlt: '2024年可持续发展报告'
                },
                '2023': {
                    title: '2023年可持续发展报告',
                    date: '发布日期：2023年4月',
                    imageAlt: '2023年可持续发展报告'
                }
            }
        },
        cta: {
            title: '与我们一起，共创可持续未来',
            description: '了解更多宜宾纸业的可持续发展实践，或与我们合作推动绿色发展',
            buttonText: '联系我们'
        }
    },
    home: {
        advantages: {
            title: "我们的优势",
            subtitle: "竹浆造纸，环保科技，品质卓越",
            items: {
                experience: {
                    title: "深厚的行业经验积累",
                    description: "80载技术沉淀，完善的制浆造纸及配套产业链，为绿色低碳生物基材料转型提供技术支撑"
                },
                production: {
                    title: "成熟规模化生产体系",
                    description: "完备的生产设施与自动化产线，可快速响应客户需求，实现低成本、高效率量产"
                },
                innovation: {
                    title: "产学研合作研发创新",
                    description: "与高校及科研机构共建有联合实验室，专注低碳工艺与可再生材料研发，加速生物基材料等前沿技术的产业化落地"
                },
                certification: {
                    title: "全链条绿色资质认证",
                    description: "从原料采购到产品生产通过FSC、医护级、卫生安全产品等认证，提升产品市场竞争力"
                }
            }
        },
        products: {
            title: "主要产品",
            subtitle: "优质竹浆纸品，满足多样需求",
            items: {
                bambooPulp: {
                    title: "原生竹浆",
                    description: "精选竹种、优质竹纤维",
                    alt: "竹浆"
                },
                packagingPaper: {
                    title: "原生竹浆包装用纸",
                    description: "强度好、耐折高、高洁净度",
                    alt: "包装用纸"
                },
                culturalPaper: {
                    title: "原生竹浆文化用纸",
                    description: "光滑细腻，书写印刷体验佳",
                    alt: "文化用纸"
                },
                livingPaper: {
                    title: "原生竹浆生活原纸",
                    description: "湿水强韧、绿色环保",
                    alt: "生活原纸"
                },
                finishedPaper: {
                    title: "原生竹浆生活成品纸",
                    description: "柔韧舒适，健康抑菌",
                    alt: "生活成品纸"
                },
                fiberMaterial: {
                    title: "纤维材料",
                    description: "功能多样，适用各种特殊需求",
                    alt: "纤维材料"
                },
                learnMore: "了解更多"
            }
        },
        about: {
            title: "关于宜宾纸业",
            description1: "宜宾纸业股份有限公司创立于1944年，是中国领先的竹浆纸生产企业，专注于竹子制浆造纸研究与生产。",
            description2: "公司位于四川省宜宾市，拥有丰富的竹资源和先进的生产设备，年产能超过50万吨高品质竹浆纸。",
            description3: "我们致力于通过技术创新和绿色生产，为客户提供优质环保的纸制品，同时推动造纸行业可持续发展。",
            learnMore: "了解更多"
        },
        sustainability: {
            title: "可持续发展",
            subtitle: "竹浆造纸，绿色循环",
            items: {
                renewable: {
                    title: "竹源可再生",
                    description: "竹子3-5年可成熟砍伐，生长迅速，是理想的可再生造纸原料"
                },
                carbon: {
                    title: "碳汇贡献",
                    description: "竹林比同等面积森林吸收更多CO₂，有效减缓气候变化"
                },
                clean: {
                    title: "清洁生产",
                    description: "采用封闭循环生产工艺，废水处理回用，实现节能减排"
                },
                rural: {
                    title: "乡村振兴",
                    description: "带动竹农增收，促进当地经济发展，实现生态与经济双赢"
                }
            }
        },
        cta: {
            title: "与我们合作，共创绿色未来",
            description: "我们期待为您提供优质的竹浆纸产品和专业服务",
            buttonText: "联系我们"
        }
    },
    contact: {
        banner: {
            title: '联系我们',
            subtitle: '随时欢迎您的咨询和反馈'
        },
        contactInfo: {
            title: '联系方式',
            subtitle: '随时欢迎您的咨询和反馈',
            address: {
                title: '公司地址',
                content: '四川省宜宾市南溪区裴石轻工业园区',
                postcode: '邮编：644100'
            },
            phone: {
                title: '电话咨询',
                main: '总机：0831-3309663',
                service: '客服热线：0831-3309689'
            },
            email: {
                title: '电子邮箱',
                service: '客户服务：ybzy@yb-zy.com',
                inquiry: '产品咨询：ybzy@yb-zy.com'
            },
            workingHours: {
                title: '工作时间',
                weekday: '周一至周五：9:00 - 17:30',
                holiday: '法定节假日休息'
            }
        },
        inquiry: {
            title: '在线咨询',
            subtitle: '填写下方表单，我们将尽快与您联系',
            form: {
                name: '您的姓名',
                company: '公司名称',
                email: '电子邮箱',
                phone: '联系电话',
                subject: '咨询主题',
                subjectPlaceholder: '请选择咨询主题',
                subjects: {
                    product: '产品咨询',
                    price: '报价咨询',
                    technical: '技术支持',
                    cooperation: '合作洽谈',
                    other: '其他问题'
                },
                message: '咨询内容',
                submit: '提交信息',
                submitting: '提交中...'
            },
            sales: {
                title: '销售服务',
                domesticRawPaper: '国内销售部(原纸)',
                domesticFinishedPaper: '国内销售部(成品纸)',
                international: '国际销售部',
                email: '销售邮箱'
            },
            afterSales: {
                title: '售后服务',
                hotlineRawPaper: '服务热线(原纸)',
                hotlineFinishedPaper: '服务热线(成品纸)',
                email: '服务邮箱'
            },
            social: {
                title: '关注我们',
                wechat: '官方微信',
                weibo: '官方微博',
                linkedin: '领英'
            }
        },
        location: {
            title: '公司位置',
            subtitle: '欢迎前来参观考察',
            mapAlt: '宜宾纸业股份有限公司地图位置',
            transport: {
                public: {
                    title: '公共交通',
                    content: '公交路线：乘坐南溪10路[中坝线]至"宜宾纸业站"下车'
                },
                driving: {
                    title: '自驾路线',
                    content: '导航至"宜宾纸业股份有限公司"，公司设有访客停车场'
                },
                airport: {
                    title: '机场交通',
                    content: '宜宾五粮液机场距离公司约58公里，可乘坐机场大巴或出租车前往'
                }
            }
        },
        offices: {
            title: '全球办事处',
            subtitle: '国际化服务网络',
            china: {
                title: '中国总部',
                flagAlt: '中国国旗',
                address: '四川省宜宾市翠屏区岷江西路159号',
                phone: '电话：0831-12345678'
            },
            usa: {
                title: '北美代表处',
                flagAlt: '美国国旗',
                address: '美国加利福尼亚州洛杉矶市橡树大道2588号',
                phone: '电话：+1-213-888-9999'
            },
            japan: {
                title: '日本代表处',
                flagAlt: '日本国旗',
                address: '日本东京都千代田区丸之内1-2-3',
                phone: '电话：+81-3-1234-5678'
            },
            europe: {
                title: '欧洲代表处',
                flagAlt: '德国国旗',
                address: '德国汉堡市汉萨街456号',
                phone: '电话：+49-40-8765-4321'
            },
            singapore: {
                title: '东南亚代表处',
                flagAlt: '新加坡国旗',
                address: '新加坡莱佛士码头10号',
                phone: '电话：+65-6789-0123'
            }
        },
        faq: {
            title: '常见问题',
            subtitle: '快速解答您的疑问'
        },
        cta: {
            title: '期待与您的沟通',
            description: '无论您有任何问题或需求，我们都将竭诚为您服务',
            buttonText: '立即咨询'
        }
    }
} 